const LOGO_STORAGE_KEY = "last-logo-visited";

/**
 * Saves the logo URL to local storage.
 * @param logoUrl - The URL of the logo to save.
 */
export function setLastLogoVisited({ logoUrl }: { logoUrl: string }): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(LOGO_STORAGE_KEY, logoUrl);
}

/**
 * Retrieves the last visited logo URL from local storage.
 * @returns The last visited logo URL or undefined if not found.
 */
export function getLastLogoVisited(): string | undefined {
  if (typeof window === "undefined") return undefined;
  return window.localStorage.getItem(LOGO_STORAGE_KEY) ?? undefined;
}

/**
 * Removes the last visited logo URL from local storage.
 */
export function clearLastLogoVisited(): void {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(LOGO_STORAGE_KEY);
}
